import { render, staticRenderFns } from "./create-product.vue?vue&type=template&id=1576ee5b&scoped=true&"
import script from "./create-product.vue?vue&type=script&lang=js&"
export * from "./create-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1576ee5b",
  null
  
)

export default component.exports